module.exports = __webpack_public_path__ + "static/media/smithCrown.6c79e74d.png";